import { createContext, useState, Dispatch, SetStateAction, useMemo } from 'react';
import { css, SerializedStyles } from '@emotion/react';
import { theme } from '@frontend/theme';
import { CoinsuranceTable, CopaymentsTable, DeductiblesTable, Maximums, Profile } from '../components';
import { GridTableEnum } from '../types';

type typeOfGridContext = {
  selected: '' | GridTableEnum;
  setSelected: Dispatch<SetStateAction<'' | GridTableEnum>>;
  selectedStyle?: SerializedStyles;
  notSelectedStyle?: SerializedStyles;
};

export const GridContainerContext = createContext<typeOfGridContext>({
  selected: '',
  setSelected: () => {},
});

export const GridContainer = () => {
  const [selected, setSelected] = useState<GridTableEnum | ''>('');

  const providerValue = useMemo(() => {
    return { selectedStyle: selectedElementStyle, notSelectedStyle: notSelectedElementStyle, selected, setSelected };
  }, [selectedElementStyle, notSelectedElementStyle, selected, setSelected]);

  return (
    <GridContainerContext.Provider value={providerValue}>
      <div css={[gridContainerStyle, selected && gridContainerWithSelectedStyle]}>
        <Profile />
        <DeductiblesTable />
        <Maximums />
        <CoinsuranceTable />
        <CopaymentsTable />
      </div>
    </GridContainerContext.Provider>
  );
};

const gridContainerStyle = css`
  display: grid;
  grid-template-columns: 30fr 28fr 42fr;
  grid-auto-rows: 264px;
  gap: ${theme.spacing(3)};
  grid-auto-flow: dense;
  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
  @media (max-width: 1200px) {
    grid-template-columns: 30fr 28fr;
  }
`;

const gridContainerWithSelectedStyle = css`
  grid-template-rows: repeat(4, 185px);
  @media (max-width: 1200px) {
    grid-template-columns: 38fr 42fr;
  }
`;

const selectedElementStyle = css`
  grid-column: 2/4;
  grid-row: 1/5;
  @media (max-width: 900px) {
    grid-row: span 4;
    grid-column: 1/3;
  }
`;

const notSelectedElementStyle = css`
  grid-column: 1/2;
`;
